<template>
  <div class="">
    <BoxAddPartes :edit="editParte"
                  :prop-cartorio="propCartorio"
                  :prop-show-modal="showModal"
                  @partEdited="partEdited"
                  @sendParte="receiveParte"
                  @hideModal="hideModal" />

    <div v-if="genitores.length"
         class="row mb-4">
      <div v-for="(data, ind) in genitores"
           :key="ind"
           class="col-6">
        <BoxGenitorParte :dados="data"
                         :indice="ind"
                         @changeDeclarante="changeDeclarante" />
      </div>
    </div>
    <BoxGenitores v-for="(parte, ind) in partes"
                  :key="ind"
                  :pessoa="parte.pessoa">
      <slot>
        <button type="button"
                class="btn btn-sm btn-danger mr-2"
                @click="removeParte(parte, ind)">
          Remover
        </button>

        <button class="btn btn-sm btn-primary"
                type="button"
                @click="editingParte(parte, ind)">
          Editar
        </button>
      </slot>
    </BoxGenitores>

    <button class="btn btn-sm btn-outline-primary btn-block btn-add-parte"
            type="button"
            @click="showModal = true">
      <IconSvg class="icon-add mr-1"
               icon="add" />
      Adicionar parte
    </button>

    <h4 class="headerTitle my-4">
      Complementos
    </h4>

    <div class="px-2">
      <div class="form-group">
        <label for="complemento"
               class="label">Complementos</label>
        <textarea id="complemento"
                  v-model="complemento"
                  class="form-control form-control-sm"
                  name="complemento"
                  placeholder="Digite aqui suas observações."
                  rows="4"
                  @change="changeData" />
      </div>
    </div>

    <h4 class="headerTitle my-4">
      Gestação e parto
    </h4>

    <form class="px-2">
      <div class="row">
        <div class="col-12 col-sm-3 col-md-2">
          <div class="form-group">
            <label class="label"
                   for="idadeMae">Idade da mãe na ocorrência</label>
            <input id="idadeMae"
                   v-model="nascimento_informacao.idade_mae"
                   class="form-control form-control-sm"
                   maxlength="2"
                   max="99"
                   min="1"
                   name="idadeMae"
                   placeholder="00"
                   type="number"
                   @keydown="validateNull('idade_mae')"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="filhosVivosAnteriores">Nº dos filhos vivos em gestações anteriores</label>
            <input id="filhosVivosAnteriores"
                   v-model="nascimento_informacao.total_filhos_vivos_gestacoes_anteriores"
                   class="form-control form-control-sm"
                   maxlength="2"
                   max="20"
                   min="0"
                   name="filhosVivosAnteriores"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="filhosMortosAnteriores">Nº de filhos mortos em gestações anteriores</label>
            <input id="filhosMortosAnteriores"
                   v-model="nascimento_informacao.total_filhos_mortos_gestacoes_anteriores"
                   class="form-control form-control-sm"
                   maxlength="2"
                   max="20"
                   min="0"
                   name="filhosMortosAnteriores"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-3 col-md-2">
          <div class="form-group">
            <label class="label"
                   for="semanadasDeGestacao">Nº de semanas de gestação</label>
            <input id="semanadasDeGestacao"
                   v-model="nascimento_informacao.total_semanas_gestacao"
                   class="form-control form-control-sm"
                   :disabled="ignorarSemanasGestacao"
                   maxlength="2"
                   max="50"
                   min="12"
                   name="semanadasDeGestacao"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-auto align-self-end mb-sm-1">
          <div class="form-group">
            <div class="custom-control custom-switch">
              <input id="ingoraSemanasGestacao"
                     v-model="ignorarSemanasGestacao"
                     class="custom-control-input"
                     name="ingoraSemanasGestacao"
                     type="checkbox"
                     @change="changeSemanasGestacao"
                     @keyup.enter="changeGestacao">
              <label class="custom-control-label"
                     for="ingoraSemanasGestacao">Ignorado</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="tipoGravidez">Tipo de gravidez</label>
            <select id="tipoGravidez"
                    v-model="nascimento_informacao.tipo_gravidez"
                    class="custom-select custom-select-sm"
                    name="tipoGravidez"
                    @change="changeData">
              <option v-for="(tipo, ind) in TIPOS_GRAVIDEZ"
                      :key="ind"
                      :value="tipo.value">
                {{ tipo.text }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="tipoParto">Tipo de parto</label>
            <select id="tipoParto"
                    v-model="nascimento_informacao.tipo_parto"
                    class="custom-select custom-select-sm"
                    name="tipoParto"
                    @change="changeData">
              <option v-for="(tipo, ind) in TIPOS_PARTO"
                      :key="ind"
                      :value="tipo.value">
                {{ tipo.text }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="consultasPreNatal">Nº de consultas pré-natal</label>
            <input id="consultasPreNatal"
                   v-model="nascimento_informacao.total_consultas_pre_natal"
                   class="form-control form-control-sm"
                   :disabled="ignorarConsultasPreNatal"
                   maxlength="2"
                   max="2000"
                   min="0"
                   name="consultasPreNatal"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-auto align-self-end mb-sm-1">
          <div class="form-group">
            <div class="custom-control custom-switch">
              <input id="ingoraPreNatal"
                     v-model="ignorarConsultasPreNatal"
                     class="custom-control-input"
                     name="registros"
                     type="checkbox"
                     @change="changeConsultasPreNatal"
                     @keyup.enter="changePreNatal">
              <label class="custom-control-label"
                     for="ingoraPreNatal">Ignorado</label>
            </div>
          </div>
        </div>
      </div>
    </form>

    <h4 class="headerTitle my-4">
      Recém nascido
    </h4>

    <form class="px-2">
      <div class="row">
        <div class="col-12 col-sm-auto">
          <div class="form-group">
            <label class="label"
                   for="indUmMinuto">Índice apgar 1º minuto</label>
            <input id="indUmMinuto"
                   v-model="nascimento.indice_apgar_1_minuto"
                   class="form-control form-control-sm"
                   maxlength="2"
                   max="99"
                   min="1"
                   name="indUmMinuto"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-auto">
          <div class="form-group">
            <label class="label"
                   for="indCincoMinuto">Índice apgar 5º minuto</label>
            <input id="indCincoMinuto"
                   v-model="nascimento.indice_apgar_5_minuto"
                   class="form-control form-control-sm"
                   maxlength="2"
                   max="99"
                   min="1"
                   name="indCincoMinuto"
                   placeholder="00"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div class="col-12 col-sm-auto">
          <div class="form-group">
            <label class="label"
                   for="corPele">Cor de Pele</label>
            <select id="corPele"
                    v-model="nascimento.cor_pele"
                    class="custom-select custom-select-sm"
                    name="corPele"
                    @change="changeData">
              <option value=""
                      selected>
                Selecione
              </option>
              <option v-for="cor in CORES_PELE"
                      :key="cor.value"
                      :value="cor.value">
                {{ cor.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-auto">
          <div class="form-row">
            <div>
              <label class="label"
                     for="pesoNascido">Peso ao Nascer</label>
              <input id="pesoNascido"
                     v-model="nascimento.peso"
                     v-mask="{ mask:'9999' }"
                     class="form-control form-control-sm col-5"
                     maxlength="4"
                     max="9999"
                     step="100"
                     min="100"
                     name="pesoNascido"
                     placeholder="0000"
                     type="text"
                     @change="changeData">
            </div>
            <div class="col-12 col-sm-auto align-self-end alignPeso">
              <label class="label">gramas(g)</label>
            </div>
          </div>
        </div>


        <div class="col-12">
          <div class="form-group form-inline align-items-center">
            <label class="label mr-4"
                   for="defeitosCongenitosNao">Possui anomalias e/ou defeitos congênitos?</label>
            <div class="d-inline-block">
              <span class="custom-control custom-radio custom-control-inline">
                <input id="defeitosCongenitosSim"
                       v-model="possuiAnomalia"
                       class="custom-control-input"
                       name="defeitosCongenitos"
                       type="radio"
                       :value="true">
                <label class="custom-control-label"
                       for="defeitosCongenitosSim">Sim</label>
              </span>

              <span class="custom-control custom-radio custom-control-inline">
                <input id="defeitosCongenitosNao"
                       v-model="possuiAnomalia"
                       class="custom-control-input"
                       checked
                       name="defeitosCongenitos"
                       type="radio"
                       :value="false"
                       @click="eraseAnomalia">
                <label class="custom-control-label"
                       for="defeitosCongenitosNao">Não</label>
              </span>
            </div>
          </div>
        </div>

        <div v-if="possuiAnomalia"
             class="col-12">
          <div class="form-group">
            <label for="anomalias_ou_defeitos"
                   class="label">Qual ?</label>
            <input id="anomalias_ou_defeitos"
                   v-model="nascimento.anomalias_ou_defeitos"
                   class="form-control form-control-sm"
                   name="anomalias_ou_defeitos"
                   :required="possuiAnomalia"
                   placeholder="Descrever todas as anomalias ou defeitos congênitos observados"
                   type="text"
                   @change="changeData">
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  /* constants  */
  import BoxAddPartes from '../../BoxAddPartes.vue'
  import BoxGenitorParte from '../../BoxGenitorParte.vue'
  import BoxGenitores from '../../../Obito/BoxGenitores.vue'

  /* utils */
  import { document } from '@/utils/nascObject'

  /* constants  */
  import objSwal from '@/constants/swalValues'
  import CORES_PELE from "@/constants/coresPele"
  import { TIPOS_PARTO, TIPOS_GRAVIDEZ } from "@/constants/dataGravidez"

  /* services */
  import NascimentoService from "@/services/Registros/Nascimento"

  /* libraries */
  import Swal from 'sweetalert2'

  export default {
    name: 'PassoOutrasOpcoes',
    components: {
      BoxAddPartes,
      BoxGenitores,
      BoxGenitorParte,
    },
    props: {
      propCartorio: {
        type: Object,
        default: () => { return {} }
      }
    },
    data () {
      return {
        document,
        CORES_PELE,
        TIPOS_PARTO,
        TIPOS_GRAVIDEZ,
        // dados que vem da API
        possuiAnomalia: false,
        editParte: {},
        nascimento: {
          cor_pele: '',
        },
        nascimento_informacao: {
          tipo_gravidez: '',
          tipo_parto: '',
        },
        complemento: '',
        registro: {},
        partes: [],
        genitores: [],
        ignorarSemanasGestacao: false,
        ignorarConsultasPreNatal: false,
        showModal: false,
        ordem_nascimento: null
      }
    },
    mounted () {
      this.checkDataPassoNascido()
    },
    methods: {
      eraseAnomalia () {
        this.nascimento.anomalias_ou_defeitos = ""
        this.possuiAnomalia = false
        this.changeData()
      },
      changeConsultasPreNatal () {
        this.nascimento_informacao.total_consultas_pre_natal = null
        this.changeData()
      },
      changeSemanasGestacao () {
        this.nascimento_informacao.total_semanas_gestacao = null
        this.changeData()
      },
      changeData () {
        this.$validator.validateAll().then((resp) => {
          if (resp) return this.updateDataPassoNascido()
        })
      },
      mountObjRetorno (val) {
        this.document = val.document
        this.partes = val.document.registro.partes
        this.registro = val.document.registro
        this.complemento = val.document.registro.complemento || ''
        this.genitores = val.document.registro.pessoa.genitores
        this.nascimento = val.document.recem_nascido
        this.nascimento_informacao = val.document.nascimento_informacao
        this.possuiAnomalia =  !!(val.document.recem_nascido.anomalias_ou_defeitos)
        this.ordem_nascimento = val.document.ordem_nascimento
      },
      mountObj () {
        return {
          registro: { ...this.document.registro, complemento: this.complemento, partes: this.partes },
          recem_nascido: { ...this.document.recem_nascido, ...this.nascimento },
          local: { ...this.document.local },
          nascimento_informacao: { ...this.document.nascimento_informacao, ...this.nascimento_informacao },
          // Partes cadastradas no primeiro passo
          gemeos: this.document.gemeos,
          local_ocorrencia: this.document.local_ocorrencia,
          ordem_nascimento: this.ordem_nascimento
        }
      },
      // API's
      async updateDataPassoNascido () {
        let { idNasc } = this.$route.params

        try {
          await NascimentoService.updateNascimentoRasc(idNasc, { document: this.mountObj() }).then(result => {
            loader({ text: '', active: false })
            return this.sendDataToContainer()
          })
        } catch (e) {
          return this.getAnError(e.message)
        }
      },
      async checkDataPassoNascido () {
        let { idNasc } = this.$route.params

        if (idNasc === 'novo') return
        loader({ text: 'Buscando dados...', active: true })

        try {
          await NascimentoService.getNascimentoRascById(idNasc).then(val => {
            this.mountObjRetorno(val)
            return this.sendDataToContainer()
          })
        } catch (e) {
          this.getAnError(e.message).then(error => {
            this.$router.push({ name: 'cadastro_nascimento', params: { idNasc: 'novo' } })
          })
        }
      },
      getAnError (text) {
        loader({ text: '', active: false })

        objSwal.error.title = 'Erro ao cadastrar'
        objSwal.error.text = text || 'Houve algum erro ao cadastrar um novo registro de nascimento, favor contactar o suporte'
        return Swal.fire(objSwal.error).then(result => loader({ text: '', active: false }))
      },
      sendDataToContainer (val) {
        loader({ text: '', active: false })
        return this.$emit('receiveData', val ? val : this.mountObj())
      },
      // receive data
      receiveParte (val) {
        let duplicated = false
        let parteObj = null

        const partes = [
          ...this.partes,
          ...this.genitores
        ]

        if (val.pessoa.cpf) {
          partes.forEach((parte) => {
            if (parte.pessoa.cpf && val.pessoa.cpf.replace(/\D+/g, '') === parte.pessoa.cpf.replace(/\D+/g, '')) {
              parteObj = parte
              duplicated = true
            }
          })
        }

        if (duplicated) {
          objSwal.error.title = `Erro ao cadastrar a parte ${val.pessoa.nome}`
          objSwal.error.text = `CPF já cadastrado para a parte ${parteObj.pessoa.nome}`
          objSwal.error.html = ''

          return Swal.fire(objSwal.error)
        }


        if (val.pessoa.cpf) {
          this.partes.forEach((parte) => {
            if (parte.pessoa.cpf && val.pessoa.cpf.replace(/\D+/g, '') === parte.pessoa.cpf.replace(/\D+/g, '')) {
              parteObj = parte
              duplicated = true
            }
          })
        }

        if (duplicated) {
          objSwal.error.title = `Erro ao cadastrar a parte ${val.pessoa.nome}`
          objSwal.error.text = `CPF já cadastrado para a parte ${parteObj.pessoa.nome}`
          objSwal.error.html = ''

          return Swal.fire(objSwal.error)
        }

        this.partes.push(val)
        Alerts.info("Parte adicionada com Sucesso!")
        this.showModal = false
        this.changeData()
      },
      editingParte (obj, indice) {
        this.editParte = { indice, edicao: true, ...obj }
        this.showModal = true
      },
      partEdited (val) {
        this.partes.splice(val.indice, 1)
        this.partes.push(val.objToAdd)
        Alerts.info("Parte atualizada com Sucesso!")
        this.showModal = false
        this.changeData()
      },
      async removeParte (parte, indice) {
        let ind = this.partes.indexOf(parte)
        const question = await Alerts.question(`Deseja excluir "${parte.pessoa.nome}"?`)

        if (question && ind !== -1) {
          this.partes.splice(ind, 1)
          Alerts.info("Parte removida com Sucesso!")

          this.changeData()
        }
      },
      changeDeclarante (val) {
        this.genitores.splice(val.indice, 1, { pessoa: val.pessoa, declarante: val.declarante })
        this.changeData()
      },
      hideModal (value) {
        this.editParte = {}
        this.showModal = value
      },
      changePreNatal () {
        setTimeout(() => {
          this.ignorarConsultasPreNatal = !this.ignorarConsultasPreNatal

          this.changeConsultasPreNatal()
        }, 200)
      },

      changeGestacao () {
        setTimeout(() => {
          this.ignorarSemanasGestacao = !this.ignorarSemanasGestacao

          this.changeSemanasGestacao()
        }, 200)
      },

      validateNull (key) {
        if (this.nascimento_informacao[key] == '') {
          this.nascimento_informacao[key] = null
        }
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../../../scss/_utilities/_exports';

  .headerTitle {
    @extend %titleBox--sm;
    background-color: $color-gray-light;
  }
  .alignPeso{
    position: relative;
    right:100px;
  }

  .btn-add-parte:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
